import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import * as React from 'react';
import useUniqueId from '../../util/useUniqueId.js';
import { useWithAbort } from '../../util/useWithAbort.js';
import { Box } from '../Box/Box.js';
import { useThemeContext } from '../../contexts/session/Theme.js';
import { useEnvironmentContext } from '../../contexts/system/Environment.js';
import { getHash } from './Illustration.mappers.js';

var _excluded = ["id", "alt"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var fetchAsset = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(baseUrl, hash) {
    var response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (hash) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return", '');
        case 2:
          _context.prev = 2;
          _context.next = 5;
          return window.fetch("".concat(baseUrl).concat(hash, ".svg"));
        case 5:
          response = _context.sent;
          _context.next = 8;
          return response.text();
        case 8:
          return _context.abrupt("return", _context.sent);
        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", '');
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 11]]);
  }));
  return function fetchAsset(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var cache = {};

// Add necessary attributes to the SVG node
var updateSvgNode = function updateSvgNode(container, alt, uniqueId) {
  var svgElement = container.querySelector('svg');
  if (svgElement) {
    if (alt) {
      svgElement.setAttribute('role', 'img');
      svgElement.setAttribute('aria-labelledby', uniqueId);
      var titleElement = document.createElement('title');
      titleElement.setAttribute('id', uniqueId);
      titleElement.textContent = alt;
      svgElement.prepend(titleElement);
    } else {
      // Decorative
      svgElement.setAttribute('aria-hidden', 'true');
    }
  }
};
var Illustration = function Illustration(props) {
  var id = props.id,
    alt = props.alt,
    rest = _objectWithoutProperties(props, _excluded);
  var environment = useEnvironmentContext();
  var assetUrl = environment.illustration.cdnUrl; // already set default value in EnvironmentContext
  var theme = useThemeContext();
  var uniqueId = useUniqueId();
  var containerRef = React.useRef(null);
  var hash = getHash(theme.name, id);
  var _useWithAbort = useWithAbort(function () {
      return fetchAsset(assetUrl, hash);
    }),
    fetchAssetWithAbort = _useWithAbort.start,
    abort = _useWithAbort.abort;
  React.useEffect(function () {
    var renderSvg = function renderSvg(svg) {
      if (containerRef.current) {
        containerRef.current.innerHTML = '';
        if (svg) {
          var container = document.createRange().createContextualFragment(svg);
          updateSvgNode(container, alt, uniqueId);
          containerRef.current.appendChild(container);
        }
      }
    };
    if (!hash) return function () {};
    if (cache[hash]) {
      renderSvg(cache[hash]);
      return function () {
        return abort();
      };
    }
    fetchAssetWithAbort().then(function (response) {
      cache[hash] = response;
      renderSvg(cache[hash]);
    }).catch(function () {});
    return function () {
      return abort();
    };
  }, [abort, alt, fetchAssetWithAbort, hash, uniqueId]);
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: containerRef
  }, rest));
};
Illustration.Decorative = function (props) {
  return Illustration(_objectSpread(_objectSpread({}, props), {}, {
    alt: ''
  }));
};
var IllustrationMemoized = /*#__PURE__*/React.memo(Illustration);
IllustrationMemoized.displayName = 'Illustration';
IllustrationMemoized.Decorative = /*#__PURE__*/React.memo(Illustration.Decorative);
IllustrationMemoized.Decorative.displayName = 'DecorativeIllustration';

export { IllustrationMemoized as Illustration, Illustration as IllustrationWithoutMemoized };
//# sourceMappingURL=Illustration.js.map
